import ShariffInjector from "@/ts/components/Shariff/ShariffInjector";
import ShariffLinkGeneratorFactory from "@/ts/components/Shariff/ShariffLinkGeneratorFactory";
import {formSubmitHandler_AddToCart_MultipleProducts} from "@/ts/components/artikelFunctions";
import EtRangeSlider from "@/ts/components/EtRangeSlider";
import FilterSetHandler from "@/ts/components/FilterSetHandler";

export default function (vwtype: string, vwname: string): void {

    const currentItem = document.querySelector('.layout_header__dnav_item.current .layout_header__dnav_button');
    const sidebarTitle = document.querySelector('.element_sidebar_navigation_h1');
    if (currentItem && sidebarTitle) {
        const backgroundColor = window.getComputedStyle(currentItem).backgroundColor;
        const color = backgroundColor === "rgba(0, 0, 0, 0)" ? "var(--color-primary)" : backgroundColor;
        ['color', 'hover', 'focus', 'active'].forEach(style => sidebarTitle.style[style] = color);
    }

    if (ShariffInjector) {
        const shariff = new ShariffInjector(new ShariffLinkGeneratorFactory());
        shariff.initButtons(window.location.href);
    }

    document.querySelectorAll(".js_themenset_detail__material_list_form").forEach((element) => {
        if (!(element instanceof HTMLFormElement)) {
            return;
        }

        if(element.dataset.a2cAlreadyInitialized === "true") return;
        element.dataset.a2cAlreadyInitialized = "true";
        element.addEventListener("submit", formSubmitHandler_AddToCart_MultipleProducts);
    });

    new EtRangeSlider();
    new FilterSetHandler();
}
